import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay
} from '@chakra-ui/react';
import { t } from 'i18next';
import { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';

interface LoungeClosureLocationState {
  fromHome?: boolean;
}

const LoungeClosureNoticePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const confirmButtonRef = useRef<HTMLButtonElement>(null);

  const handleConfirm = () => {
    const state = location.state as LoungeClosureLocationState | null;
    if (state?.fromHome) {
      navigate(-1);
      return;
    }

    navigate('/home', { replace: true });
  };

  return (
    <main className="min-h-screen bg-background">
      <Helmet>
        <title>{t('LoungeChatPage.closureNotice.title')}</title>
      </Helmet>
      <AlertDialog
        isOpen={true}
        onClose={handleConfirm}
        leastDestructiveRef={confirmButtonRef}
        closeOnOverlayClick={false}
        isCentered={true}
      >
        <AlertDialogOverlay className="!z-[2147483647]">
          <AlertDialogContent
            className="!max-h-[calc(100dvh-32px)] !overflow-hidden !rounded-[40px] !bg-background-elevated"
            marginX="6%"
            boxShadow="0 4px 14px rgba(0, 0, 0, 0.25)"
          >
            <AlertDialogHeader
              className="text-center text-[17px] font-bold text-text-main-lv1"
              paddingX="32px"
              paddingTop="32px"
              paddingBottom="8px"
            >
              {t('LoungeChatPage.closureNotice.title')}
            </AlertDialogHeader>
            <AlertDialogBody
              className="overflow-y-auto whitespace-pre-line text-center text-[15px] leading-[22px] text-text-main-lv4"
              paddingX="32px"
              paddingY="0"
            >
              {t('LoungeChatPage.closureNotice.description')}
            </AlertDialogBody>
            <AlertDialogFooter paddingX="32px" paddingTop="20px" paddingBottom="16px">
              <button
                ref={confirmButtonRef}
                type="button"
                className="w-full rounded-full bg-primary-light px-[34px] py-[16px] text-[17px] font-semibold leading-[20px] text-pure-white outline-none focus-visible:ring-2 focus-visible:ring-primary-light focus-visible:ring-offset-2 dark:bg-primary-dark"
                onClick={handleConfirm}
              >
                {t('confirm')}
              </button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </main>
  );
};

export default LoungeClosureNoticePage;
